import { render, staticRenderFns } from "./accountStep3.vue?vue&type=template&id=5a9d0332&"
import script from "./accountStep3.vue?vue&type=script&lang=js&"
export * from "./accountStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports